import { View } from '@react-pdf/renderer'

import { commonPdfTableStyles } from '@features/exports/utils/commonTableStyles'

import { useColumnLabels } from '../../../hooks/useColumnLabels'
import type { ReportSection as ReportSectionType } from '../../../types/reportSection'
import { FieldsList } from './FieldsList'
import { HeaderRow, SubheaderRow } from './Header'

interface ReportSectionProps {
  block: ReportSectionType
  countryId?: string
  locale?: string
  currency?: string
}

export const ReportSection = ({ block, countryId, locale, currency }: ReportSectionProps) => {
  const { mainHeader, subheader, fields, reserveSymbolColumn = false } = block

  const fieldsForColumns = subheader?.fieldsForLabels ?? fields
  const { labels, amountKeys } = useColumnLabels({ countryId, fields: fieldsForColumns })

  const subheaderText = (subheader?.leftText ?? '').trim()
  const showSubheader = subheaderText.length > 0 || labels.length > 0

  return (
    <View style={commonPdfTableStyles.wrapper}>
      {mainHeader && <HeaderRow symbol={mainHeader.symbol} title={mainHeader.title} />}
      {showSubheader && subheader && (
        <SubheaderRow labels={labels} leftText={subheader.leftText} reserveSymbolColumn={reserveSymbolColumn} />
      )}
      {fields.length > 0 && <FieldsList amountKeys={amountKeys} currency={currency} fields={fields} locale={locale} />}
    </View>
  )
}
